import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-900 border-t border-cyan-500/20">
      <div className="container mx-auto px-6 py-8">
        <div className="flex justify-center items-center text-center">
          <p className="text-slate-400 text-sm mb-4 md:mb-0">© 2026 BinPacker Cloud App - Project by Andrei Baban</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


